import { render } from "./chart-morris.vue?vue&type=template&id=556e0b62"
import script from "./chart-morris.vue?vue&type=script&lang=js"
export * from "./chart-morris.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__